import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private jwtHelper: JwtHelperService;

  constructor() {
    this.jwtHelper = new JwtHelperService();
  }

  decodeToken(token: string): any {
    try {
      return this.jwtHelper.decodeToken(token);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  getDetailsFromToken(token: string): { appRole: string, [key: string]: any } | null {
    const profile = this.decodeToken(token);
    
    if (!profile) {
      return null;
    }

    let appRole = profile.tokenData.role;
    
    // Apply the specific logic for role '2' and status '4'
    if (profile.tokenData.role === '2' && profile.tokenData.status === '4') {
      appRole = '5';
    }

    return {
      ...profile,
      appRole
    };
  }
}